import { render, staticRenderFns } from "./PatientPanelHeader.vue?vue&type=template&id=a79467fe&scoped=true"
import script from "./PatientPanelHeader.vue?vue&type=script&lang=js"
export * from "./PatientPanelHeader.vue?vue&type=script&lang=js"
import style0 from "./PatientPanelHeader.vue?vue&type=style&index=0&id=a79467fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79467fe",
  null
  
)

export default component.exports